import { useCallback, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Loader } from "@/components/common";
import CodePad from "@/components/vault/CodePad";

// Public page from the "Forgot vault code" email (1 hour). Sets a new code; shows no documents.
export default function VaultReset() {
  const [params] = useSearchParams();
  const t = params.get("t") || "";
  const [ok, setOk] = useState(null);
  const [first, setFirst] = useState(null);
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(null);
  useEffect(() => { api.get(`/vault/reset/${encodeURIComponent(t)}`).then(() => setOk(true)).catch((e) => { setOk(false); setErr(errMsg(e)); }); }, [t]);
  const submit = useCallback(async (code) => {
    if (!first) { setFirst(code); setErr(null); return; }
    try { const { data } = await api.post("/vault/reset", { token: t, code: first, confirm: code }); setDone(data.organization_id); } catch (e) { setErr(errMsg(e)); setFirst(null); }
  }, [first, t]);
  return (
    <div className="flex min-h-screen items-center justify-center bg-q-bg px-5" data-testid="vault-reset-page">
      <div className="q-card w-full max-w-md p-6">
        {ok === null ? <Loader /> : !ok ? <p className="text-center text-q-text" data-testid="vault-reset-invalid">{err}</p> : done ? (
          <div className="text-center" data-testid="vault-reset-done">
            <p className="font-display text-2xl font-extrabold text-q-text">New vault code set</p>
            <Link to={`/h/${done}/family/vault`} className="q-btn q-btn-primary mt-5 min-h-[44px]" data-testid="vault-reset-open">Open the Vault</Link>
          </div>
        ) : <CodePad key={first ? "2" : "1"} title={first ? "Enter it again" : "Choose a new vault code"} hint="6 digits, only for you." error={err} onSubmit={submit} testid="vault-reset-pad" />}
      </div>
    </div>
  );
}
